<div class="grid grid-cols-1 w-full min-w-0">
    <div style="display: none">
        <p>Search String</p>
        <!-- <app-table-filter
            [searchForm]="searchForm"
            (stringResult)="onSelectedString($event)"
        ></app-table-filter> -->
        <hr />
    </div>
    <form [formGroup]="formGroup" class="grid grid-cols-1">
        <div class="grid grid-cols-2 gap-4 my-2">
            <div>
                <mat-form-field class="custom-mat-form-field w-full">
                    <mat-label> Platform </mat-label>
                    <input type="text" matInput formControlName="platformName" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="custom-mat-form-field w-full">
                    <mat-label>Well Name</mat-label>
                    <input type="text" aria-label="Number" matInput formControlName="wellName" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="custom-mat-form-field w-full">
                    <mat-label>Well Type</mat-label>
                    <input type="text" aria-label="Number" matInput formControlName="wellType" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="custom-mat-form-field w-full">
                    <mat-label>Flow Category</mat-label>
                    <input type="text" aria-label="Number" matInput formControlName="wellFlowCategory" />
                </mat-form-field>
            </div>
        </div>
    </form>
    <hr />
    <form [formGroup]="formGroup" class="grid grid-cols-1">
        <div class="grid grid-cols-3 gap-2 my-2">
            <div>
                <mat-label>Well Status Prior Handover</mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <input matInput class="input input-bordered" type="text" formControlName="wellStatus" />
                </mat-form-field>
            </div>
            <div>
                <mat-label>Injection Rate </mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <input matInput formControlName="injectionRateMmscfD" type="number" />
                    <span matTextSuffix>mmscf/d</span>
                </mat-form-field>
            </div>

            <div>
                <mat-label>Production Rate </mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <input matInput formControlName="productionRateBblDay" type="number" />
                    <span matTextSuffix>bbls/d</span>
                </mat-form-field>
            </div>
        </div>
        <div class="grid grid-cols-3 gap-2 my-2">
            <div>
                <mat-label>Shut-in Time</mat-label>
                <input matInput type="time" formControlName="shutInTimeHrs"
                    class="input input-bordered w-full text-md" />
            </div>
            <div>
                <mat-label>Tester</mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <input matInput formControlName="tester" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="w-full">
                    <mat-label>Date</mat-label>
                    <input matInput [matDatepicker]="picker" class="input input-bordered w-full"
                        formControlName="date" />
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
        <hr />
        <mat-label class="my-2"> Xmas Tree Details : </mat-label>
        <div class="grid grid-cols-5 gap-4 my-2">
            <div>
                <mat-label> Rating </mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <input type="text" aria-label="Number" matInput formControlName="xmtRating" />
                </mat-form-field>
            </div>
            <div>
                <mat-label> Size </mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <input type="text" aria-label="Number" matInput formControlName="xmtSize" />
                </mat-form-field>
            </div>
            <div>
                <mat-label> OEM </mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <input type="text" aria-label="Number" matInput formControlName="xmtOem" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="custom-mat-form-field w-full">
                    <mat-label> Gas Lifted Well </mat-label>
                    <select matNativeControl formControlName="isGasLiftedWell">
                        <option [value]="true">Yes</option>
                        <option [value]="false">No</option>
                    </select>
                </mat-form-field>
            </div>
            <div>
                <mat-label> Gas Lift Header </mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <input type="number" matInput formControlName="gasLiftedHeader" />
                    <span matTextSuffix>psi</span>
                </mat-form-field>
            </div>
        </div>
        <hr />
        <div class="grid grid-cols-4 gap-4 my-2 mb-6">
            <!-- <div>
                <mat-label> Tree Cap Connection </mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <input matInput formControlName="treeCapConn" />
                </mat-form-field>
            </div> -->
            <!-- <div>
                <mat-label> If Others </mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <input matInput formControlName="treeCapConnRemarks" />
                </mat-form-field>
            </div> -->

            <div class="col-span-2">
                <mat-label> Tree Cap Condition </mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <mat-select matNativeControl formControlName="treeCapCond">
                        <mat-option value="LEAK"> LEAK </mat-option>
                        <mat-option value="CORRODED"> CORRODED </mat-option>
                        <mat-option value="DAMAGED"> DAMAGED </mat-option>
                        <mat-option value="GOOD"> GOOD </mat-option>
                        <mat-option value="OTHERS"> OTHERS </mat-option>
                    </mat-select>

                    <!-- <input type="text" matInput formControlName="treeCapCond" [matAutocomplete]="treeCapCond" />
                    <mat-autocomplete #treeCapCond="matAutocomplete">
                        <mat-option value="LEAK"> LEAK </mat-option>
                        <mat-option value="CORRODED"> CORRODED </mat-option>
                        <mat-option value="DAMAGED"> DAMAGED </mat-option>
                        <mat-option value="OTHERS"> OTHERS </mat-option>
                    </mat-autocomplete> -->
                </mat-form-field>
            </div>
            <div class="col-span-2">
                <mat-label> If Others </mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <input matInput formControlName="treecapCondRemarks" />
                </mat-form-field>
            </div>

            <!-- <div>
                <mat-label> Size </mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <input id="location-abbreviation" matInput type="number" formControlName="size" step="0.01" min="0"
                        (blur)="formatDecimal('size')" />
                </mat-form-field>
            </div>
            <div>
                <mat-label> Thread </mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <input id="location-abbreviation" matInput formControlName="thread" />
                </mat-form-field>
            </div> -->

        </div>
        <div class="grid grid-cols-3 gap-3 my-2">
            <div>
                <mat-label> Void Area (as found) </mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <input matInput id="location-abbreviation" formControlName="voidArea" type="number" />
                    <span matTextSuffix>psi</span>
                </mat-form-field>
            </div>
            <div>
                <mat-label> Void Area (after b/off) </mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <input id="location-abbreviation" matInput formControlName="voidAreaAfter" type="number" />
                    <span matTextSuffix>psi</span>
                </mat-form-field>
            </div>
            <div>
                <mat-label> Pressure build up test </mat-label>
                <div class="grid grid-cols-3 gap-2">
                    <mat-form-field class="custom-mat-form-field w-full">
                        <mat-select matNativeControl formControlName="isPressureBuildUpTest">
                            <mat-option [value]="true">Yes</mat-option>
                            <mat-option [value]="false">No</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="custom-mat-form-field w-full col-span-2">
                        <input id="location-abbreviation" matInput formControlName="pressureBuildUpTest" />
                        <span matTextSuffix>psi/15mins</span>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="grid grid-cols-2 gap-2 my-2">
            <div>
                <mat-label> Xmas Tree Physical Condition </mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <input id="location-abbreviation" matInput formControlName="xmtPhysCond" />
                </mat-form-field>
            </div>
            <div>
                <mat-label> Wellhead Physical Condition </mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <input id="location-abbreviation" matInput formControlName="wellheadPhysCond" />
                </mat-form-field>
            </div>
        </div>
    </form>
    <hr />

    <form [formGroup]="headerForm" class="grid grid-cols-2">
        <mat-form-field appearance="fill" class="col-span-2" *ngIf="!isViewOnly">
            <mat-label><b>Remarks: </b> Relevant Documents</mat-label>
            <ngx-mat-dropzone class="p-2">
                <input multiple type="file" placeholder="Click/Drag to upload" fileInput formControlName="attachments"
                    accept="image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
                <mat-chip-row *ngFor="
                        let item of formGroup
                            .get('cdftAttachments')
                            .getRawValue();
                        index as i
                    " (click)="view($event, i)" class="mt-4">
                    {{ item?.name?.value }}
                    <button matChipRemove (click)="remove(item, i)">
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip-row>
            </ngx-mat-dropzone>
            <mat-hint>Click/Drag to upload</mat-hint>
            <mat-icon matSuffix color="primary">cloud_upload</mat-icon>
            <mat-error>Invalid file type</mat-error>
        </mat-form-field>

        <div *ngIf="isViewOnly" class="col-span-2">
            <label class="mb-2">
                <b>Remarks: </b> Picture report to be attached and submitted!
            </label>
            <div *ngIf="formGroup.get('cdftAttachments')?.getRawValue()?.length == 0" class="rounded border p-2">
                No Attachments
            </div>
            <div>
                <mat-chip-row *ngFor="
                        let item of formGroup.get('cdftAttachments').getRawValue();
                        index as i
                    " (click)="view($event, i)" class="mt-2 mx-2">
                    {{ item?.name?.value }}
                </mat-chip-row>
            </div>

        </div>
    </form>
    <hr />

    <form [formGroup]="formGroup" class="grid grid-cols-2 gap-4 w-full mb-6">
        <div>
            <mat-label> Imposed Pressure ? </mat-label>
            <mat-form-field class="custom-mat-form-field w-full">
                <mat-select matNativeControl formControlName="isImposedPressure">
                    <mat-option [value]="true">Yes</mat-option>
                    <mat-option [value]="false">No</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div>
            <mat-label> If Yes </mat-label>
            <mat-form-field class="custom-mat-form-field w-full">
                <input id="location-abbreviation" matInput formControlName="imposedPressure" type="number" />
                <span matTextSuffix>psi</span>
            </mat-form-field>
        </div>
    </form>


    <label>String Details</label>
    <form [formGroup]="formGroup" class="grid grid-cols-2 gap-4 w-full ">
        <div class="my-2">
            <mat-label>FTHP</mat-label>
            <mat-form-field class="custom-mat-form-field w-full">
                <input matInput class="input" formControlName="fthp" type="number" />
                <span matTextSuffix>psi</span>
            </mat-form-field>
        </div>
        <div class="my-2">
            <mat-label>SITHP</mat-label>
            <mat-form-field class="custom-mat-form-field w-full">
                <input matInput class="input" formControlName="sithp" type="number" />
                <span matTextSuffix>psi</span>
            </mat-form-field>
        </div>
        <div class="my-2">
            <mat-label>PCP (A)</mat-label>
            <mat-form-field class="custom-mat-form-field w-full">
                <input matInput class="input" formControlName="pcp" type="number" />
                <span matTextSuffix>psi</span>
            </mat-form-field>
        </div>
        <div class="my-2">
            <mat-label>ICP (B)</mat-label>
            <mat-form-field class="custom-mat-form-field w-full">
                <input matInput class="input" formControlName="icp" type="number" />
                <span matTextSuffix>psi</span>
            </mat-form-field>
        </div>
        <div class="my-2">
            <mat-label>SCP (C)</mat-label>
            <mat-form-field class="custom-mat-form-field w-full">
                <input matInput class="input" formControlName="scp" type="number" />
                <span matTextSuffix>psi</span>
            </mat-form-field>
        </div>
        <div class="my-2">
            <mat-label>CCP (D)</mat-label>
            <mat-form-field class="custom-mat-form-field w-full">
                <input matInput class="input" formControlName="ccp" type="number" />
                <span matTextSuffix>psi</span>
            </mat-form-field>
        </div>
        <div class="my-2">
            <mat-label>Header</mat-label>

            <mat-form-field class="custom-mat-form-field w-full">
                <input matInput class="input" formControlName="header" type="number" />
                <span matTextSuffix>psi</span>
            </mat-form-field>
        </div>
    </form>


    <!-- <div class="grid grid-cols-2 w-full min-w-0">
        <form [formGroup]="formGroup" class="grid grid-cols-1 mr-2">
            <div class="my-2 mb-8">
                <mat-label> Imposed Pressure ? </mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <mat-select matNativeControl formControlName="isImposedPressure">
                        <mat-option [value]="true">Yes</mat-option>
                        <mat-option [value]="false">No</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <label>String Details</label>
            <div class="my-2">
                <mat-label>FTHP</mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <input matInput class="input" formControlName="fthp" type="number" />
                    <span matTextSuffix>psi</span>
                </mat-form-field>
            </div>
            <div class="my-2">
                <mat-label>SITHP</mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <input matInput class="input" formControlName="sithp" type="number" />
                    <span matTextSuffix>psi</span>
                </mat-form-field>
            </div>
            <div class="my-2">
                <mat-label>PCP (A)</mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <input matInput class="input" formControlName="pcp" type="number" />
                    <span matTextSuffix>psi</span>
                </mat-form-field>
            </div>
            <div class="my-2">
                <mat-label>ICP (B)</mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <input matInput class="input" formControlName="icp" type="number" />
                    <span matTextSuffix>psi</span>
                </mat-form-field>
            </div>
            <div class="my-2">
                <mat-label>SCP (C)</mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <input matInput class="input" formControlName="scp" type="number" />
                    <span matTextSuffix>psi</span>
                </mat-form-field>
            </div>
            <div class="my-2">
                <mat-label>CCP (D)</mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <input matInput class="input" formControlName="ccp" type="number" />
                    <span matTextSuffix>psi</span>
                </mat-form-field>
            </div>
            <div class="my-2">
                <mat-label>Header</mat-label>

                <mat-form-field class="custom-mat-form-field w-full">
                    <input matInput class="input" formControlName="header" type="number" />
                    <span matTextSuffix>psi</span>
                </mat-form-field>
            </div>
        </form>

        <form class="grid grid-cols-1" [formGroup]="headerForm.controls.stringStatus">
            <form [formGroup]="formGroup">
                <div class="my-2 mb-8">
                    <mat-label> If Yes </mat-label>
                    <mat-form-field class="custom-mat-form-field w-full">
                        <input id="location-abbreviation" matInput formControlName="imposedPressure" type="number" />
                        <span matTextSuffix>psi</span>
                    </mat-form-field>
                </div>
            </form>


            <label>String Status</label>
            <div class="my-2">
                <mat-label>Active (PTN)</mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <input type="text" aria-label="Number" matInput formControlName="activePTN" />
                </mat-form-field>
            </div>
            <div class="my-2">
                <mat-label>Active (PTL)</mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <input type="text" aria-label="Number" matInput formControlName="activePTL" />
                </mat-form-field>
            </div>
            <div class="my-2">
                <mat-label>Intermittent</mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <input type="text" aria-label="Number" matInput formControlName="intermittent" />
                </mat-form-field>
            </div>
            <div class="my-2">
                <mat-label>Gas Injector</mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <input type="text" aria-label="Number" matInput formControlName="gasInjector" />
                </mat-form-field>
            </div>
            <div class="my-2">
                <mat-label>Water Injector</mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <input type="text" aria-label="Number" matInput formControlName="waterInjector" />
                </mat-form-field>
            </div>
            <div class="my-2">
                <mat-label>Idle Producer</mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <input type="text" aria-label="Number" matInput formControlName="idleProducer" />
                </mat-form-field>
            </div>
            <div class="my-2">
                <mat-label>Idle Injector</mat-label>
                <mat-form-field class="custom-mat-form-field w-full">
                    <input type="text" aria-label="Number" matInput formControlName="idleInjector" />
                </mat-form-field>
            </div>
        </form>
    </div> -->
</div>